import { displayErrorToast } from "./ToastUtils";

export function handleUnauthorisedException() {
  window.localStorage.clear();
  displayErrorToast("An error has occurred. Please log out and log back in.");
}
